// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4LDLz","header":"styles_header__rycdC","content":"styles_content__bweab","expanded":"styles_expanded__2jepE"};